var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8984 6.46753V13.8144",
    stroke: "white",
    strokeWidth: 1.95917
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8984 21.896V41.7326",
    stroke: "white",
    strokeWidth: 1.95917
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0413 6.46753L23.5106 15.2838C23.5106 17.0374 22.814 18.7193 21.574 19.9593C20.3339 21.1993 18.6521 21.896 16.8984 21.896C15.1448 21.896 13.463 21.1993 12.2229 19.9593C10.9829 18.7193 10.2863 17.0374 10.2863 15.2838L11.7556 6.46753",
    stroke: "white",
    strokeWidth: 1.95917
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9391 29.9775H28.6534C28.6534 29.9775 30.8575 9.40628 38.9391 6.46753V41.7325",
    stroke: "white",
    strokeWidth: 1.95917
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.b4afa7a2f9c6754d57d6a6cd909408f6.svg";
export { ForwardRef as ReactComponent };